export interface ForemanCrewDto {
  bActive?: boolean | null;
  JobCrewName?: string;
  JobCrewID?: string;
  JobID?: string | null;
  Shift?: number | null;
  employeeJobIDs?: string[];
  jobCrewID?: string;
  jobID?: string;
  name?: string;
  shift?: number;
}
